import { useContext } from 'react';

import { CastContext } from './CastContext';

export const useCastContext = () => {
  const context = useContext(CastContext);
  return { ...context };
};
